module.exports = __webpack_public_path__ + "static/media/speech_recognition.94be5488.PNG";